module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-1.ebc9fc55.jpg";